import type { Activity } from "api";
import type { LoadStatus } from "hooks/useProfile";
import { formatRelativeTime } from "utils/date.utils";
import { DashboardCard } from "./DashboardCard";

type ActivityCardProps = {
  activity: Activity[];
  status: LoadStatus;
};

/**
 * What happened in the account lately. The feed belongs to the company, so a
 * colleague's action appears here too, and says whose it was.
 */
export const ActivityCard = ({ activity, status }: ActivityCardProps) => (
  <DashboardCard
    title="Recent activity"
    sub="Across everyone in your company"
    status={status}
    isEmpty={activity.length === 0}
    empty="Nothing has happened here yet."
    failure="Could not load recent activity. Please refresh the page."
  >
    <ul className="dsh__act">
      {activity.map((entry) => (
        <li key={entry.id}>
          <span>{formatRelativeTime(entry.created_at)}</span>
          <div>
            <b>{entry.subject === null ? entry.label : `${entry.label} · ${entry.subject}`}</b>
            {/* The actor closes the line: on a shared feed, who did it is half
                of what the row says. */}
            <em>{[...entry.details, entry.actor?.name].filter(Boolean).join(" · ")}</em>
          </div>
        </li>
      ))}
    </ul>
  </DashboardCard>
);
